<template>
    <v-chip
        v-if="offer.type && offer.type.toLowerCase() !== 'other'"
        color="blue-grey-lighten-1"
        size="x-small"
        label
        v-text="offer.type"
    />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelTypeLabel extends Vue {
        @Prop({required: true}) offer
    }

    export default HotelTypeLabel
</script>
